var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"pre-view-driver",on:{"click":_vm.driver.reStart}},[_c('i',{staticClass:"gattaran-wentifankui"}),_c('span',[_vm._v(_vm._s(_vm.$t('Gattaran_Homepage__uCVu' /*查看引导*/)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }